export const BUDGET = 1 //Orçamento
export const PROJECT_ADEQUACY = 2 //Projeto Adequação
export const PROJECT_ART = 3 //Art do Projeto
export const PURCHASE_ORDER = 4 //Ordem de compra
export const FINALIZED_ADEQUACY_PICTURE = 5 //Foto Adequação Finalizada
export const HOMOLOGATION_REPORT = 6 //Laudo de Homologação
